import { render, staticRenderFns } from "./coaching_goal_modify.vue?vue&type=template&id=3274eac9"
import script from "./coaching_goal_modify.vue?vue&type=script&lang=js"
export * from "./coaching_goal_modify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports